import { classes } from "@shared/api/services";
import { useQuery } from "@tanstack/react-query"

export const useAllOrders = () => {
    return useQuery({
        queryKey: ['orders'],
        queryFn: () => classes.getAllOrders(),
        select: (data) => data.data
    });
};